//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export enum UniversalSearchSortDirection {
  Asc = 'Asc',
  Desc = 'Desc',
}
